import { Building2 } from "lucide-react";
import { Section, SectionHeading } from "@/components/common/Section";
import { useReveal } from "@/hooks/useReveal";
import { industries } from "@/data/content";

function IndustryCard({ name, index }) {
  const ref = useReveal();
  return (
    <div
      ref={ref}
      style={{ transitionDelay: `${(index % 4) * 60}ms` }}
      data-testid={`industry-card-${index}`}
      className="reveal group flex items-center gap-4 bg-white border border-black/5 px-5 py-5 transition-all duration-300 hover:border-gold/60 hover:-translate-y-1 hover:shadow-[0_16px_32px_rgba(10,31,68,0.06)]"
    >
      <span className="flex h-10 w-10 shrink-0 items-center justify-center bg-mist text-navy transition-colors duration-300 group-hover:bg-gold group-hover:text-navy">
        <Building2 className="h-5 w-5" />
      </span>
      <span className="text-sm md:text-base font-medium text-navy">{name}</span>
    </div>
  );
}

export function Industries() {
  return (
    <Section id="industries" bg="white">
      <SectionHeading
        eyebrow="Industries We Serve"
        title="Trusted across every kind of workspace"
        subtitle="From IT parks to retail showrooms, we deliver branding and signage tailored to each industry's environment and audience."
        align="center"
      />
      <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {industries.map((name, i) => (
          <IndustryCard key={name} name={name} index={i} />
        ))}
      </div>
    </Section>
  );
}
